module.exports = __webpack_public_path__ + "img/landing-page.f37e0454.jpg";